module.exports = __webpack_public_path__ + "static/9-76cc8d6e7ba0435d875c9806fd6a0949.png";